import { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import ReactPlayer from 'react-player';
import { useAnomalies, useStatuses, useTargetRegions } from '@shared';
import { MyParams } from 'App';
import { useActionAudit } from './hooks';

export default function useReviewHook() {
  const { session: sessionUuid, audit: auditUuid } = useParams<keyof MyParams>() as MyParams;

  const [isPlaying, setIsPlaying] = useState(false);
  const [playedSeconds, setPlayedSeconds] = useState(0);
  const [playbackRate, setPlaybackRate] = useState(1.0);
  const [progressPlayed, setProgressPlayed] = useState(0);
  const playerRef = useRef<ReactPlayer>(null);

  const [isOpenReviewIdentity, setOpenReviewIdentity] = useState(false);
  const [isOpenComments, setOpenComments] = useState(false);
  const [isConfirmationOpen, setConfirmationOpen] = useState(false);
  const [isActionAlertOpen, setActionAlertOpen] = useState(false);

  const { statuses, updateStatuses, isStatusesLoading, refetchStatuses } = useStatuses(auditUuid);

  const { restartAudit, finishAudit } = useActionAudit(auditUuid, refetchStatuses);

  const { data: anomalies, refetch: refetchAnomalies } = useAnomalies(auditUuid);

  const { data: targetRegions = [] } = useTargetRegions(auditUuid);

  const handleSeekChange = (seek: number, isPlay = true) => {
    setIsPlaying(isPlay);
    playerRef.current?.seekTo(seek);
  };

  const toggleConfirmationOpen = () => setConfirmationOpen((prev) => !prev);

  const handleApproveConfirm = () => {
    statuses?.auditFinished ? restartAudit() : finishAudit();
    toggleConfirmationOpen();
    !statuses?.auditFinished && setActionAlertOpen(true);
  };

  return {
    isPlaying,
    isStatusesLoading,
    isOpenReviewIdentity,
    isOpenComments,
    isConfirmationOpen,
    isActionAlertOpen,

    playedSeconds,
    playbackRate,
    progressPlayed,
    playerRef,

    sessionUuid,
    auditUuid,
    targetRegions,
    anomalies,
    statuses,

    handleSeekChange,
    toggleConfirmationOpen,
    handleApproveConfirm,

    setPlayedSeconds,
    setPlaybackRate,
    setProgressPlayed,
    setIsPlaying,
    setOpenReviewIdentity,
    setOpenComments,
    setActionAlertOpen,
    updateStatuses,
    refetchAnomalies,
  };
}
